import translationsEn from 'assets/translations/en-GB.json';
import translationsPl from 'assets/translations/pl-PL.json';
import translationsHu from 'assets/translations/hu-HU.json';
import translationsIt from 'assets/translations/it-IT.json';
import translationsRo from 'assets/translations/ro-RO.json';
import translationsBg from 'assets/translations/bg-BG.json';
import translationsNl from 'assets/translations/nl-NL.json';
import plPl from 'antd/lib/locale/pl_PL';
import enGb from 'antd/lib/locale/en_GB';
import huHu from 'antd/lib/locale/hu_HU';
import itIt from 'antd/lib/locale/it_IT';
import roRo from 'antd/lib/locale/ro_RO';
import bgBg from 'antd/lib/locale/bg_BG';
import nlNl from 'antd/lib/locale/nl_NL';
import { Locale } from 'antd/lib/locale-provider';
import { Locale as DateFnsLocale } from 'date-fns';
import { enGB, hu, it, pl, ro, bg, nl } from 'date-fns/locale';
export enum LanguageName {
  EN = 'en',
  HU = 'hu',
  IT = 'it',
  PL = 'pl',
  RO = 'ro',
  BG = 'bg',
  NL = 'nl',
}

export interface AppLanguage {
  name: LanguageName;
  code: string;
  translations: any;
  antdLocale: Locale;
}

// Not defining locale key as LanguageName because it is locale value from antd locales
// refer to lib/antd/pickerGenerateDateFns dealLocal (small caps without dialect)
// todo: potential optimization via lazy load
export const dateFnsLocale: Record<string, DateFnsLocale> = {
  pl: pl,
  en: enGB,
  hu: hu,
  it: it,
  ro: ro,
  bg: bg,
  nl: nl,
};

export const defaultLanguage = {
  name: LanguageName.EN,
  code: 'en-GB',
  translations: translationsEn,
  antdLocale: enGb,
};

export const languages = [
  defaultLanguage,
  {
    name: LanguageName.PL,
    code: 'pl-PL',
    translations: translationsPl,
    antdLocale: plPl,
  },
  {
    name: LanguageName.HU,
    code: 'hu-HU',
    translations: translationsHu,
    antdLocale: huHu,
  },
  {
    name: LanguageName.IT,
    code: 'it-IT',
    translations: translationsIt,
    antdLocale: itIt,
  },
  {
    name: LanguageName.RO,
    code: 'ro-RO',
    translations: translationsRo,
    antdLocale: roRo,
  },
  {
    name: LanguageName.BG,
    code: 'bg-BG',
    translations: translationsBg,
    antdLocale: bgBg,
  },
  {
    name: LanguageName.NL,
    code: 'nl-NL',
    translations: translationsNl,
    antdLocale: nlNl,
  },
];

export const languageStorageKey = 'HIGO-language';
